import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconSearchBold';
/** Renders an SVG icon. */
const SvgSearchBold = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M28.414 28.414a2 2 0 0 0 0-2.828l-5.491-5.492A11.45 11.45 0 0 0 25 13.5C25 7.149 19.851 2 13.5 2S2 7.149 2 13.5 7.149 25 13.5 25c2.453 0 4.727-.768 6.594-2.077l5.492 5.491a2 2 0 0 0 2.828 0M13.5 21a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15"
      />
    </svg>
  );
};
SvgSearchBold.displayName = displayName;
export default SvgSearchBold;
